import { memo } from "react";
import { Label } from "./general";

const toggleShellClass =
  "h-8 p-0.5 bg-surface rounded-md outline outline-1 outline-offset-[-1px] outline-[color:rgb(var(--color-border-muted))] inline-flex w-full max-w-full sm:w-auto justify-start items-center overflow-hidden";
const activeBtnClass =
  "flex-1 w-full px-3 bg-primary rounded shadow-sm flex justify-center items-center gap-1 border-0 cursor-pointer text-surface text-xs font-medium leading-5";
const inactiveBtnClass =
  "flex-1 w-full px-3 rounded flex justify-center items-center gap-1 border-0 cursor-pointer bg-transparent text-strong text-xs font-normal leading-5";

/**
 * Label on the start side + compact two-option segmented toggle on the end.
 * Pass pre-translated `label` strings in each option.
 */
const LabeledSegmentedToggle = ({
  label,
  options = [],
  value,
  onChange,
  required = false,
  className = "",
}) => (
  <div className={`flex justify-between items-center ${className}`}>
    {label && <Label title={label} required={required} />}
    <div className={toggleShellClass}>
      {options.map(({ value: optionValue, label: optionLabel }) => {
        const isActive = value === optionValue;
        return (
          <button
            key={String(optionValue)}
            type="button"
            aria-pressed={isActive}
            onClick={() => onChange?.(optionValue)}
            className={isActive ? activeBtnClass : inactiveBtnClass}
          >
            <span className="truncate">{optionLabel}</span>
          </button>
        );
      })}
    </div>
  </div>
);

export default memo(LabeledSegmentedToggle);
